module.exports = __webpack_public_path__ + "img/img_boss_phone.716eb0bd.png";